import modpacks from '../data/modpacks';
import ModpackCard from '../components/ModpackCard';

export default function Home() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-purple-300 text-center">Hosted Modpacks</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 ">
        {modpacks.map(modpack => (
          <ModpackCard key={modpack.id} modpack={modpack} />
        ))}
      </div>
    </div>
  );
}